/**
 * api接口统一管理
 */
import { post } from './axios'

/**
 *
 * @param {string} params
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 *
 * topics({
            page:this.pageIndex,
            tab:this.tabType,
            limit:this.pageSize
        }).then( res=> {
            console.log(res)
            this.topicsLists = res.data;
        })
 */
/* ******************************************************* example start ******************************************************** */
// export const getMyCourses = (params, page, limit) => post('user.php?type=getMyCourses&p=' + page + '&num=' + limit, params) // 我的微课
// export const getMyTeaching = params => get('user.php?type=getMyTeaching', params) // 我的教辅资料
// export const teacherLogin = params => post('teacher.php?type=login', params) // 登录 共用
/* ******************************************************* example end ******************************************************** */
export const getIndexImg = () => post('api.php?cla=mtApi&fun=getIndexImg') // 首页轮播图
export const getCaseImg = () => post('api.php?cla=mtApi&fun=getCaseImg') // 首页经典案例
export const getInquiryImg = () => post('api.php?cla=mtApi&fun=getInquiryImg') // 首页资讯动态
export const setMessage = params => post('api.php?cla=mtApi&fun=setMessage', params) // 留言
export const getInquiryIndex = params => post('api.php?cla=mtApi&fun=getInquiryIndex', params) // 资讯动态首页
export const getInquiryDetail = params => post('api.php?cla=mtApi&fun=getInquiryDetail', params) // 资讯动态详情
export const getCaseType = () => post('api.php?cla=mtApi&fun=getCaseType') // 案例首页获取分类
export const getCaseAddr = () => post('api.php?cla=mtApi&fun=getCaseAddr') // 获取经典案例地区
export const getCaseIndex = params => post('api.php?cla=mtApi&fun=getCaseIndex', params) // 经典案例首页
export const getCaseDetail = params => post('api.php?cla=mtApi&fun=getCaseDetail', params) // 经典案例详情
export const getTeamIndex = params => post('api.php?cla=mtApi&fun=getTeamIndex', params) // 核心团队首页
export const getTeamDetail = params => post('api.php?cla=mtApi&fun=getTeamDetail', params) // 成员详情
export const getDesignDepartment = () => post('api.php?cla=mtApi&fun=getDesignDepartment') // 设计部门搜索数据
export const getDesignDepartmentName = params => post('api.php?cla=mtApi&fun=getDesignDepartmentName', params) // 获取设计部门名称
export const getDesignIndex = params => post('api.php?cla=mtApi&fun=getDesignIndex', params) // 设计部门首页
export const getContent = params => post('api.php?cla=mtApi&fun=getContent', params) //  关于我们，项目管理体系
export const getHonorIndex = params => post('api.php?cla=mtApi&fun=getHonorIndex', params) //  获取荣誉资质
export const getLinkUs = () => post('api.php?cla=mtApi&fun=getLinkUs') //  联系我们
export const getFooter = () => post('api.php?cla=mtApi&fun=getFooter') //  尾部信息
export const getRecruitIndex = params => post('api.php?cla=mtApi&fun=getRecruitIndex', params) // 招聘求职首页
export const getRecruitDetail = params => post('api.php?cla=mtApi&fun=getRecruitDetail', params) // 招聘求职详情
